import React from 'react';
import PropTypes from 'prop-types';

import Card from 'components/common/Card';
import DoughnutChart from 'components/common/DoughnutChart';
import ChartLabel from 'components/common/ChartLabel';

const LabelsCard = ({ labels = [] }) => {

  const getCustomLabels = () => (
    labels.map(({ name, color }) => (
      <div
        className="column is-one-third-desktop is-half-touch is-flex is-align-items-center my-1"
        key={name}
      >
        <ChartLabel
          label={name}
          color={color}
        />
      </div>
    ))
  );

  return (
    <Card>
      <h3 className="has-text-weight-bold has-text-light mb-2">
        Labels
      </h3>
      <div className="columns is-multiline">
        <div
          className="column is-12 columns is-variable is-1 is-multiline"
          style={{ width: '100%', minHeight: 192 }}
        >
          {getCustomLabels()}
        </div>
        <div className="column is-12">
          <DoughnutChart
            id="labels-chart"
            data={labels.map(label => label.count)}
            labels={labels.map(label => label.name)}
            backgroundColor={labels.map(label => label.color)}
            circumference={180}
            rotation={270}
            width={400}
            height={200}
          />
        </div>
      </div>
    </Card>
  );
};

LabelsCard.propTypes = {
  labels: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      color: PropTypes.string,
      count: PropTypes.number
    })
  ),
};

export default LabelsCard;
